import React from "react";
import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Income.css";
import { url } from "../../../../../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import MainTable from "./MainTable/MainCAMTable";
import BankIncome from "./BankIncome/BankIncome.jsx";
import CashIncome from "./CashIncome/CashIncometable.jsx";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from "js-cookie";
import PrimaryIncome from "./PrimaryIncomeComplete/PrimaryIncome.jsx";
import MilkIncomeSelectionModal from "./MilkIncomeSelectionModal.jsx";
import { useParams } from "react-router-dom";
import SalaridIncome from "./SalariedIncome.jsx";

const Income = () => {
  const { loanid } = useParams();
  const loanId = loanid;
  const [open, setOpen] = React.useState(false);
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData?.borrower || {};
  const coapplicant = borrowerData?.coapplicant || [];
  const fetchLoanDetails = borrowerData?.loan || [];
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [income1TableData, setIncome1TableData] = useState(null);
  const [income1TableDataEdit, setIncome1TableDataEdit] = useState(null);
  const [income2TableData, setIncome2TableData] = useState(null);
  const [income2TableDataEdit, setIncome2TableDataEdit] = useState(null);
  const [income3TableData, setIncome3TableData] = useState(null);
  const [income3TableDataEdit, setIncome3TableDataEdit] = useState(null);
  const [income4TableData, setIncome4TableData] = useState(null);
  const [income4TableDataEdit, setIncome4TableDataEdit] = useState(null);
  const [borrwer_cam_milk_income, setBorrwerCamilkIncome] = useState({});
  const [cattleTableData, setCattleTableData] = useState({});
  const [newDataa, setNewData] = useState({});
  const [incomeMargin, setIncomeMargin] = useState("");
  const [filteredCoapplicants, setFilteredCoapplicants] = useState([]);
  const [visible, setvisible] = useState(false);
  const [addPrimary, setAddPrimary] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isBorrower, setIsBorrower] = useState(true);
  const [coapplicantId, setCoapplicantId] = useState("");
  const [quickAi, setQuickAi] = useState(false);
  const [aiStatus, setAiStatus] = useState([]);
  const [isStatusChange, setIsStatusChange] = useState("");
  const [selectedLoan, setSelectedLoan] = useState({});
  const foundLoan = fetchLoanDetails.find((item) => item?.loan_id === loanId);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanId) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const handleFromModal = (value) => {
    console.log("called with:", value, isStatusChange);
    setIsStatusChange(value);
  };

  useEffect(() => {
    if (!loanId || !borrowerData?.loan?.length) return;

    const matchedLoan = borrowerData.loan.find(
      (item) => String(item?.loan_id) === String(loanId)
    );

    if (matchedLoan) {
      setSelectedLoan(matchedLoan);
      console.log("Selected Loan:", matchedLoan);
    } else {
      setSelectedLoan({});
    }
  }, [loanId, borrowerData?.loan]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (loanId) {
      const filtered = borrowerData.coapplicant.filter(
        (coapplicant) => coapplicant.coapplicant_loan_id === loanId
      );
      setFilteredCoapplicants(filtered);
      mappedLoanId(loanId);
    } else {
      setFilteredCoapplicants([]);
    }

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
      setQuickAi(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email,
        })
        .then((res) => {
          setAddPrimary(res.data[0]?.permission.add_primary_cam);
          setQuickAi(res.data[0]?.permission.milk_statement_ai_analysis);
        })
        .catch((err) => {
          console.error("Error fetching user permissions:", err);
          toast.error("Failed to load user permissions");
        });
    }

    if (loanId && email && token) {
      axios
        .post(url + "/apiCallLog/get", {
          token: token,
          email: email,
          loan_id: loanId,
        })
        .then((res) => {
          console.log("API Call Log Response:", res.data);
          const rawData = res.data?.data || [];
          const transformed = rawData.map((item) => ({
            api_call_id: item?.api_call_id
              ? item.api_call_id.replace("_milk_statement", "")
              : "",
            status: item?.milkstatement_ai_status || "",
          }));

          console.log(transformed);
          setAiStatus(transformed);
          console.log("Transformed AI Status:", transformed);
        })
        .catch((err) => {
          console.error("Error fetching API call log:", err);
          const errorMsg =
            err.response?.data?.message || "Failed to fetch AI status logs";
          toast.error(errorMsg);
        });
    }
    mappedLoanId();
    //eslint-disable-next-line
  }, [loanId, borrowerData?.coapplicant, email, token]);

  console.log(filteredCoapplicants);

  const mappedLoanId = () => {
    if (!loanId || !token || !email) return;
    setOpen(true);
    axios
      .post(url + "/cam/get/cam/data", {
        token: token,
        email: email,
        loanId: loanId,
      })
      .then((res) => {
        console.log(res.data);
        setBorrwerCamilkIncome(res.data?.borrwer_cam_milk_income);
        setNewData(res.data?.borrwer_cam_cattle_income);
        setIncome1TableDataEdit(res.data?.borrower_main_income);
        setIncome2TableDataEdit(res.data?.coborrower_income_1);
        setIncome3TableDataEdit(res.data?.coborrower_income_2);
        setIncome4TableDataEdit(res.data?.coborrower_income_3);
        setIncomeMargin(res?.data?.margin);
        setOpen(false);
      })
      .catch((err) => {
        console.error("Error fetching CAM data:", err);
        const errorMsg =
          err.response?.data?.message || "Failed to load CAM data";
        toast.error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
      });
  };

  const borrowerMilkData = (fieldName, value) => {
    let updatedBorrowerDate = { ...borrwer_cam_milk_income };
    updatedBorrowerDate[fieldName] = value;
    setBorrwerCamilkIncome(updatedBorrowerDate);
  };

  const borrower_main_income_1 = (obj) => {
    setIncome1TableData(obj);
  };

  const borrower_main_income_2 = (obj) => {
    setIncome2TableData(obj);
  };

  const borrower_main_income_3 = (obj) => {
    setIncome3TableData(obj);
  };

  const borrower_main_income_4 = (obj) => {
    setIncome4TableData(obj);
  };

  const borrwer_cam_cattle_income = (obj) => {
    setCattleTableData(obj);
  };

  const handleSave = async () => {
    try {
      const res = await axios.post(url + "/cam/add/income/data", {
        token: token,
        email: email,
        loanId: loanId,
        borrwer_cam_milk_income: borrwer_cam_milk_income,
        borrwer_cam_cattle_income: cattleTableData,
        margin: incomeMargin,
      });
      console.log(res);
    } catch (err) {
      console.error("Error saving draft income data:", err);
      const errorMsg =
        err.response?.data?.message || "Failed to save income data draft";
      toast.error(errorMsg);
    }
  };

  const handleSubmit = async () => {
    setOpen(true);
    axios
      .post(url + "/cam/add/income/data", {
        token: token,
        email: email,
        loanId: loanId,
        borrower_main_income: income1TableData,
        coborrower_income_1: income2TableData,
        coborrower_income_2: income3TableData,
        coborrower_income_3: income4TableData,
        borrwer_cam_milk_income: borrwer_cam_milk_income,
        borrwer_cam_cattle_income: cattleTableData,
        margin: incomeMargin,
      })
      .then(async (res) => {
        console.log(res);
        toast.success(res.data?.message || "Income data submitted successfully!");

        try {
          let update = await axios.post(url + "/cam/get/cam/data", {
            token: token,
            email: email,
            loanId: loanId,
          });
          setBorrwerCamilkIncome(update.data?.borrwer_cam_milk_income || {});
          setNewData(update.data?.borrwer_cam_cattle_income || {});
          setIncome1TableDataEdit(update.data?.borrower_main_income || null);
          setIncome2TableDataEdit(update.data?.coborrower_income_1 || null);
          setIncome3TableDataEdit(update.data?.coborrower_income_2 || null);
          setIncome4TableDataEdit(update.data?.coborrower_income_3 || null);
          setIncomeMargin(update.data?.margin || "");
        } catch (fetchErr) {
          console.error("Error refreshing CAM data after submit:", fetchErr);
          toast.error("Data saved, but failed to refresh local view.");
        }
      })
      .catch((err) => {
        console.error("Error submitting income data:", err);
        const errorMsg =
          err.response?.data?.message || "Failed to submit income data";
        toast.error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
      });
  };

  console.log(
    coapplicant,
    coapplicant?.coapplicant_milkstatement &&
    coapplicant?.coapplicant_milkstatement?.length > 0,
    "coapplicant"
  );

  console.log(
    selectedLoan?.loan_milkstatement &&
    selectedLoan?.loan_milkstatement?.length > 0,
    "selectedLoan"
  );

  const calculateTotal = () => {
    let totalMonthlyPayment = 0;
    if (borrwer_cam_milk_income?.mainBorrowerMITBA === "Yes") {
      totalMonthlyPayment += parseFloat(
        income1TableDataEdit?.avragePayout || 0
      );
    }
    if (borrwer_cam_milk_income?.coborrower1MITBA === "Yes") {
      totalMonthlyPayment += parseFloat(
        income2TableDataEdit?.avragePayout || 0
      );
    }
    if (borrwer_cam_milk_income?.coborrower2MITBA === "Yes") {
      totalMonthlyPayment += parseFloat(
        income3TableDataEdit?.avragePayout || 0
      );
    }
    if (borrwer_cam_milk_income?.coborrower3MITBA === "Yes") {
      totalMonthlyPayment += parseFloat(
        income4TableDataEdit?.avragePayout || 0
      );
    }
    return isNaN(totalMonthlyPayment) ? 0 : totalMonthlyPayment;
  };

  console.log(borrwer_cam_milk_income?.mainBorrowerSTW);

  return (
    <div className="obligation-form">
      <hr className="hori-line" />
      {selectedLoan?.loan_professiontype === "SELF-EMPLOYED" ? (
        <div className="SELF_EMPLOYED">
          {loanId && (
            <div className="income-container">
              <table className="report-table-income">
                <thead style={{ backgroundColor: 'rgb(207, 226, 243)' }}>
                  <tr>
                    <th>Borrower Type</th>
                    <th>Borrower Name</th>
                    <th>Supply to Whom</th>
                    <th>Milk Payment Computation</th>
                    <th>Milk Payment Mode</th>
                    <th>Income To Be Added</th>
                    {quickAi && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Applicant</td>
                    <td>
                      {fetchedBorrowerDetails?.borrower_firstname +
                        " " +
                        fetchedBorrowerDetails?.borrower_middlename +
                        " " +
                        fetchedBorrowerDetails?.borrower_lastname}
                    </td>
                    <td>
                      <select
                        className="income-select"
                        value={borrwer_cam_milk_income?.mainBorrowerSTW || ""}
                        onChange={(e) =>
                          borrowerMilkData("mainBorrowerSTW", e.target.value)
                        }
                        disabled={isDisbursed}
                      >
                        <option value="">Select </option>
                        <option value="cooprative">Cooprative</option>
                        <option value="private-dairy">Private dairy</option>
                        <option value="open-market">Open Market</option>
                        <option value="mpc">MPc</option>
                        <option value="milk-aggregator">Milk Aggregator</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="income-select"
                        value={borrwer_cam_milk_income?.mainBorrowerMPC || ""}
                        onChange={(e) =>
                          borrowerMilkData("mainBorrowerMPC", e.target.value)
                        }
                        disabled={isDisbursed}
                      >
                        <option value="">Select </option>
                        <option value="Bank">Bank</option>
                        <option value="Cash">Cash</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="income-select"
                        value={borrwer_cam_milk_income?.mainBorrowerMPM || ""}
                        onChange={(e) =>
                          borrowerMilkData("mainBorrowerMPM", e.target.value)
                        }
                        disabled={isDisbursed}
                      >
                        <option value="">Select </option>
                        <option value="Bank">Bank</option>
                        <option value="Cash">Cash</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="income-select"
                        value={borrwer_cam_milk_income?.mainBorrowerMITBA || ""}
                        onChange={(e) =>
                          borrowerMilkData("mainBorrowerMITBA", e.target.value)
                        }
                        disabled={isDisbursed}
                      >
                        <option value="">Select </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                    {quickAi && (
                      <td>
                        {(() => {
                          const statusItem = aiStatus.find(
                            (item) => item?.api_call_id === loanId
                          );
                          const status = statusItem?.status;

                          const isDisabled =
                            status === "Processing" ||
                            [
                              borrwer_cam_milk_income?.mainBorrowerSTW,
                              borrwer_cam_milk_income?.mainBorrowerMPC,
                              borrwer_cam_milk_income?.mainBorrowerMPM,
                              borrwer_cam_milk_income?.mainBorrowerMITBA,
                              selectedLoan?.loan_milkstatement?.length > 0,
                            ].some(
                              (v) => v === undefined || v === null || v === ""
                            );

                          return (
                            <>
                              {status && (
                                <span className="ai-status">{status}</span>
                              )}
                              <button
                                className="analyse-btn"
                                disabled={isDisabled || isDisbursed}
                                onClick={() => {
                                  setIsBorrower(true);
                                  setCoapplicantId("");
                                  handleSave();
                                  setOpenModal(true);
                                }}
                              >
                                Quick AI
                              </button>
                            </>
                          );
                        })()}
                      </td>
                    )}
                  </tr>
                  {filteredCoapplicants.length === 0
                    ? null
                    : filteredCoapplicants.map((coapp, index) => (
                      <tr key={coapp?.coapplicant_id || index}>
                        <td>Co-Applicant</td>
                        <td>{coapp?.coapplicant_name || "N/A"}</td>
                        <td>
                          <select
                            className="income-select"
                            value={
                              (borrwer_cam_milk_income &&
                                borrwer_cam_milk_income[
                                `coborrower${index + 1}STW`
                                ]) ||
                              ""
                            }
                            onChange={(e) =>
                              borrowerMilkData(
                                `coborrower${index + 1}STW`,
                                e.target.value
                              )
                            }
                            disabled={isDisbursed}
                          >
                            <option value="">Select </option>
                            <option value="cooprative">Cooprative</option>
                            <option value="private-dairy">
                              Private dairy
                            </option>
                            <option value="open-market">Open Market</option>
                            <option value="mpc">MPc</option>
                            <option value="milk-aggregator">
                              Milk Aggregator
                            </option>
                          </select>
                        </td>
                        <td>
                          <select
                            className="income-select"
                            value={
                              (borrwer_cam_milk_income &&
                                borrwer_cam_milk_income[
                                `coborrower${index + 1}MPC`
                                ]) ||
                              ""
                            }
                            onChange={(e) =>
                              borrowerMilkData(
                                `coborrower${index + 1}MPC`,
                                e.target.value
                              )
                            }
                            disabled={isDisbursed}
                          >
                            <option value="">Select </option>
                            <option value="Bank">Bank</option>
                            <option value="Cash">Cash</option>
                          </select>
                        </td>
                        <td>
                          <select
                            className="income-select"
                            value={
                              (borrwer_cam_milk_income &&
                                borrwer_cam_milk_income[
                                `coborrower${index + 1}MPM`
                                ]) ||
                              ""
                            }
                            onChange={(e) =>
                              borrowerMilkData(
                                `coborrower${index + 1}MPM`,
                                e.target.value
                              )
                            }
                            disabled={isDisbursed}
                          >
                            <option value="">Select </option>
                            <option value="Bank">Bank</option>
                            <option value="Cash">Cash</option>
                          </select>
                        </td>
                        <td>
                          <select
                            className="income-select"
                            value={
                              (borrwer_cam_milk_income &&
                                borrwer_cam_milk_income[
                                `coborrower${index + 1}MITBA`
                                ]) ||
                              ""
                            }
                            onChange={(e) =>
                              borrowerMilkData(
                                `coborrower${index + 1}MITBA`,
                                e.target.value
                              )
                            }
                            disabled={isDisbursed}
                          >
                            <option value="">Select </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </td>
                        {quickAi && (
                          <td>
                            {(() => {
                              const statusItem = aiStatus.find(
                                (item) =>
                                  item?.api_call_id === coapp?.coapplicant_id
                              );
                              const status = statusItem?.status;

                              const isDisabled =
                                status === "Processing" ||
                                [
                                  borrwer_cam_milk_income?.[
                                  `coborrower${index + 1}STW`
                                  ],
                                  borrwer_cam_milk_income?.[
                                  `coborrower${index + 1}MPC`
                                  ],
                                  borrwer_cam_milk_income?.[
                                  `coborrower${index + 1}MPM`
                                  ],
                                  borrwer_cam_milk_income?.[
                                  `coborrower${index + 1}MITBA`
                                  ],
                                  !coapp?.coapplicant_milkstatement?.length
                                    ? ""
                                    : "ok",
                                ].some(
                                  (v) =>
                                    v === undefined || v === null || v === ""
                                );

                              return (
                                <>
                                  {status && (
                                    <span className="ai-status">
                                      {status}
                                    </span>
                                  )}
                                  <button
                                    className="analyse-btn"
                                    disabled={isDisabled || isDisbursed}
                                    onClick={() => {
                                      setIsBorrower(false);
                                      setCoapplicantId(
                                        coapp?.coapplicant_id || ""
                                      );
                                      handleSave();
                                      setOpenModal(true);
                                    }}
                                  >
                                    Quick AI
                                  </button>
                                </>
                              );
                            })()}
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
              <MilkIncomeSelectionModal
                modalStatus={openModal}
                closeModal={() => setOpenModal(false)}
                isBorrower={isBorrower}
                coapplicant_id={coapplicantId}
                loan_id={loanId}
                statusChange={handleFromModal}
              />
            </div>
          )}
          <br />

          {loanId && (
            <MainTable
              onObjectReceived={borrwer_cam_cattle_income}
              newDataa={newDataa}
              isDisbursed={isDisbursed}
            />
          )}
          <br />
          <br />

          {borrwer_cam_milk_income?.mainBorrowerMPC === "Bank" &&
            borrwer_cam_milk_income?.mainBorrowerMITBA === "Yes" && (
              <>
                <BankIncome
                  onObjectReceived={borrower_main_income_1}
                  income1TableDataEdit={income1TableDataEdit}
                  customerName={
                    fetchedBorrowerDetails?.borrower_firstname +
                    " " +
                    fetchedBorrowerDetails?.borrower_middlename +
                    " " +
                    fetchedBorrowerDetails?.borrower_lastname
                  }
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.mainBorrowerMPC === "Cash" &&
            borrwer_cam_milk_income?.mainBorrowerMITBA === "Yes" && (
              <>
                <CashIncome
                  onObjectReceived={borrower_main_income_1}
                  income1TableDataEdit={income1TableDataEdit}
                  customerName={
                    fetchedBorrowerDetails?.borrower_firstname +
                    " " +
                    fetchedBorrowerDetails?.borrower_middlename +
                    " " +
                    fetchedBorrowerDetails?.borrower_lastname
                  }
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower1MPC === "Bank" &&
            borrwer_cam_milk_income?.coborrower1MITBA === "Yes" && (
              <>
                <BankIncome
                  onObjectReceived={borrower_main_income_2}
                  income2TableDataEdit={income2TableDataEdit}
                  customerName={filteredCoapplicants[0]?.coapplicant_name || ""}
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower1MPC === "Cash" &&
            borrwer_cam_milk_income?.coborrower1MITBA === "Yes" && (
              <>
                <CashIncome
                  onObjectReceived={borrower_main_income_2}
                  income2TableDataEdit={income2TableDataEdit}
                  customerName={filteredCoapplicants[0]?.coapplicant_name || ""}
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower2MPC === "Bank" &&
            borrwer_cam_milk_income?.coborrower2MITBA === "Yes" && (
              <>
                <BankIncome
                  onObjectReceived={borrower_main_income_3}
                  income3TableDataEdit={income3TableDataEdit}
                  customerName={filteredCoapplicants[1]?.coapplicant_name || ""}
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower2MPC === "Cash" &&
            borrwer_cam_milk_income?.coborrower2MITBA === "Yes" && (
              <>
                <CashIncome
                  onObjectReceived={borrower_main_income_3}
                  income3TableDataEdit={income3TableDataEdit}
                  customerName={filteredCoapplicants[1]?.coapplicant_name || ""}
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower3MPC === "Bank" &&
            borrwer_cam_milk_income?.coborrower3MITBA === "Yes" && (
              <>
                <BankIncome
                  onObjectReceived={borrower_main_income_4}
                  income4TableDataEdit={income4TableDataEdit}
                  customerName={filteredCoapplicants[2]?.coapplicant_name || ""}
                  isDisbursed={isDisbursed}
                />
                <br />
              </>
            )}

          {borrwer_cam_milk_income?.coborrower3MPC === "Cash" &&
            borrwer_cam_milk_income?.coborrower3MITBA === "Yes" ? (
            <CashIncome
              onObjectReceived={borrower_main_income_4}
              income4TableDataEdit={income4TableDataEdit}
              customerName={filteredCoapplicants[2]?.coapplicant_name || ""}
              isDisbursed={isDisbursed}
            />
          ) : null}

          {loanId && (
            <div className="nbfc-div">
              {(addPrimary || visible) && (
                <button
                  type="submit"
                  className="nbfc-btn"
                  onClick={handleSubmit}
                  disabled={isDisbursed}
                >
                  Submit
                </button>
              )}
            </div>
          )}

          {loanId && (
            <PrimaryIncome
              totalIncome={calculateTotal()}
              loanID={loanId}
              incomeMargin={incomeMargin}
              isDisbursed={isDisbursed}
            />
          )}

          <ToastContainer />
        </div>
      ) : (
        <div className="SALARIED">
          <SalaridIncome loanid={loanid} borrowerData={borrowerData} />
        </div>
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Income;